export default {
  label: {
    title: 'Filtros globais',
    description: 'Aqui você define as regras de filtragem para todo o dashboard.',
    notClassified: 'Não Classificados',
    filters: {
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Tags',
      status: 'Status',
      repliers: 'Respondentes',
      contract: 'Contrato',
      bot: 'Bot',
      channels: 'Canais',
      operators: 'Atendentes',
      teams: 'Filas',
    },
    button: {
      cancelButton: 'Cancelar',
      confirmButton: 'Aplicar',
      clearButton: 'Limpar tudo',
      primaryButton: 'Confirmar',
    },
    listening: {
      subtitle: 'Publicações',
      session: {
        what: 'O que',
        when: 'Quando',
        where: 'Onde',
        who: 'Quem',
      },
    },
    sac: {
      subtitle: 'Métricas Proprietárias e Smart Care',
    },
    blip: {
      subtitle: 'Blip',
    },
    desk: {
      subtitle: 'Atendimento Humano',
    },
  },
};
